import {NameValueDTO} from '../../common/models/NameValueDTO';
import {BaseDTO} from '../../common/models/BaseDTO';

export class GrandfatherDTO extends BaseDTO {
  grandfatherId: number;
  name: string;
  policy: NameValueDTO;
  insuredPerson: NameValueDTO;
  nationalDrugFormulary: NameValueDTO;
}
